
import { useNavigate } from 'react-router-dom';

interface DashboardProps {
  onLogout: () => void;
}

export default function Dashboard({ onLogout }: DashboardProps) {
  const navigate = useNavigate();

  const stats = [
    { title: '今日报销单', value: '12', icon: 'ri-file-text-line', color: 'bg-blue-500' },
    { title: '待审核', value: '5', icon: 'ri-time-line', color: 'bg-yellow-500' },
    { title: '已通过', value: '8', icon: 'ri-check-line', color: 'bg-green-500' },
    { title: '总金额', value: '¥15,680', icon: 'ri-money-dollar-circle-line', color: 'bg-purple-500' }
  ];

  const recentReports = [
    { id: 1, user: '张三', amount: '¥1,200', type: '差旅费', status: '待审核', date: '2024-01-15' },
    { id: 2, user: '李四', amount: '¥800', type: '办公用品', status: '已通过', date: '2024-01-15' },
    { id: 3, user: '王五', amount: '¥2,500', type: '培训费', status: '待审核', date: '2024-01-14' },
    { id: 4, user: '赵六', amount: '¥600', type: '餐费', status: '已通过', date: '2024-01-14' },
    { id: 5, user: '钱七', amount: '¥1,800', type: '交通费', status: '待审核', date: '2024-01-13' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-slate-100">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            返回首页
          </button>
          <div className="text-center flex-1">
            <h1 className="text-4xl font-bold mb-2" style={{ color: 'rgb(17, 50, 99)' }}>管理后台</h1>
            <p className="text-gray-600">报销系统管理中心</p>
          </div>
          <button
            onClick={onLogout}
            className="flex items-center px-4 py-2 text-red-600 hover:text-red-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-logout-box-line mr-2"></i>
            退出登录
          </button>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-600 text-sm mb-1">{stat.title}</p>
                  <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                </div>
                <div className={`${stat.color} p-3 rounded-lg`}>
                  <i className={`${stat.icon} text-white text-xl`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Recent Reports Table */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">最近报销单</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    报销人
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    金额
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    类型
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    状态
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    日期
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    操作
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {recentReports.map((report) => (
                  <tr key={report.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {report.user}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {report.amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {report.type}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                        report.status === '已通过' 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-yellow-100 text-yellow-800'
                      }`}>
                        {report.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {report.date}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <button className="text-blue-600 hover:text-blue-900 mr-3 cursor-pointer whitespace-nowrap">
                        查看
                      </button>
                      {report.status === '待审核' && (
                        <>
                          <button className="text-green-600 hover:text-green-900 mr-3 cursor-pointer whitespace-nowrap">
                            通过
                          </button>
                          <button className="text-red-600 hover:text-red-900 cursor-pointer whitespace-nowrap">
                            拒绝
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
